import React from 'react';
import LazyLoad from 'react-lazyload';

import GalleryInline from './GalleryInline';
import GalleryLeft from './GalleryLeft';
import GalleryRight from './GalleryRight';

import './style.css';

/**
 * Блок "Работы учеников".
 * 
 * @param {Object} props                данные, пришедшие от родителя
 * @param {Array} props.gallery_arr     массив галерей из родителя
 * @memberof ArticlePage
 */
export const PW = (props) => (
  <div className="pupils-work">
    <h2 className="pupil-work_header">Сделано учениками</h2>
    {
      props.gallery_arr.map((item, index) => {
        if (item.type === 'inline') {
          return(
            <LazyLoad key={index} height={1000} once offset={100}>
              <GalleryInline gallery={item.data} />
            </LazyLoad>
          )
        } else if (item.type === 'left') {
          return(
            <LazyLoad key={index} height={1000} once offset={100}>
              <GalleryLeft gallery={item.data}
                           main_image={item.main_image} />
            </LazyLoad>
          )
        } else if (item.type === 'right') {
          return(
            <LazyLoad key={index} height={1000} once offset={100}>
              <GalleryRight gallery={item.data}
                            main_image={item.main_image} />
            </LazyLoad>
          )
        } else return null
      })
    }
  </div>
)

export default PW;
